var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 8.99984C0.666504 4.39746 4.39747 0.666504 8.99984 0.666504C13.6022 0.666504 17.3332 4.39747 17.3332 8.99984C17.3332 13.6022 13.6022 17.3332 8.99984 17.3332C4.39746 17.3332 0.666504 13.6022 0.666504 8.99984ZM9.83317 6.18642C9.83317 5.72618 9.46007 5.35309 8.99984 5.35309C8.5396 5.35309 8.1665 5.72618 8.1665 6.18642V6.18736C8.1665 6.6476 8.5396 7.02069 8.99984 7.02069C9.46007 7.02069 9.83317 6.6476 9.83317 6.18736V6.18642ZM9.83317 8.99986C9.83317 8.53962 9.46007 8.16653 8.99984 8.16653C8.5396 8.16653 8.1665 8.53962 8.1665 8.99986V12.3332C8.1665 12.7934 8.5396 13.1665 8.99984 13.1665C9.46007 13.1665 9.83317 12.7934 9.83317 12.3332V8.99986Z",
    fill: "#4338CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.55a851af0293a1d984d44755333b50d3.svg";
export { ForwardRef as ReactComponent };